import { render, staticRenderFns } from "./AppRecommend.vue?vue&type=template&id=0c291b35&scoped=true&"
var script = {}
import style0 from "./AppRecommend.vue?vue&type=style&index=0&id=0c291b35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c291b35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c291b35')) {
      api.createRecord('0c291b35', component.options)
    } else {
      api.reload('0c291b35', component.options)
    }
    module.hot.accept("./AppRecommend.vue?vue&type=template&id=0c291b35&scoped=true&", function () {
      api.rerender('0c291b35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_eagle_landing/components/AppRecommend.vue"
export default component.exports